import { useState, useEffect, useContext, useRef } from 'react';

import { requestApi } from '../../../util/utility';
import { cmnContext } from '../../common/CmnContext';
import { SaleListContext } from './SaleListContext';
import { SaleListSearch } from './search/SaleListSearch';
import { SaleListBanner } from './banner/SaleListBanner';
import { SaleListItem } from './item/SaleListItem';
import { SaleListNoData } from './noData/SaleListNoData';
import { SaleListLoading } from './loading/SaleListLoading';
import Modal from '../../common/Modal';
import { SaleListDetailModal } from './detailModal/SaleListDetailModal';
import Loading from '../../common/loading/Loading';

import { SaleModel, SaleBannerModel } from '../../../models/sale/Sale';


export function SaleList() {
  // パラメータ
  const params = new URLSearchParams(window.location.search);
  // ハッシュタグ
  const hash = window.location.hash;
  const hashValue = hash.replace(/^#/, '');

  const isPc = useContext(cmnContext).isPc;

  const [user, setUser] = useState<any>(null);
  const [userOrg, setUserOrg] = useState<any>(null);
  const [isPlus, setIsPlus] = useState<boolean>(false);
  const [isFullAccess, setIsFullAccess] = useState<boolean>(false);
  const [isCheckFullAccess, setIsCheckFullAccess] = useState<boolean>(false);
  const [isFullaccessPurchased, setIsFullaccessPurchased] = useState<boolean>(false);
  const [config, setConfig] = useState(null);
  const [telecomUrl, setTelecomUrl] = useState<string>('');
  const [telecomTag, setTelecomTagb] = useState<string>('');
  const [TELECOM_CLIENTIP, SET_TELECOM_CLIENTIP] = useState<string>('');
  const [BASE_URL_SSL, SET_BASE_URL_SSL] = useState<string>('');
  const [SUBSCRIPTION_NAME, SET_SUBSCRIPTION_NAME] = useState<string>('');

  // バナー情報
  const [bannerList, setBannerList] = useState<SaleBannerModel[]>([]);

  // 最後に実行したAPIを優先する(重複実行防止)
  const latestRequestId = useRef(0);

  // 初回表示
  const [firstSaleId, setFirstSaleId] = useState<string|null>(params.get('target_id'));

  // 動画一覧　
  const [dispSaleList, setDispSaleList] = useState<SaleModel[]>([]);
  const defaultSaleTypeList = {
    'normal': [] as SaleModel[],
    'new': [] as SaleModel[],
    'benefit': [] as SaleModel[],
    'plus': [] as SaleModel[],
    'purchased': [] as SaleModel[],
    'favorite': [] as SaleModel[],
  };
  const [saleTypeList, setSaleTypeList] = useState(defaultSaleTypeList);

  // 講師一覧
  const [instList, setInstList] = useState([]);

  // 検索
  const [searchWord, setSearchWord] = useState<string>(params.get('keyword') || '');
  const [searchedWordList, setSearchedWordList] = useState<string[]>([]);

  // 検索ラベル
  const searchLabel = {
    'new': '新着',
    'benefit': '特典付',
    'plus': 'プラス無料',
    'purchased': '所持中',
    'favorite': 'お気に入り',
  }
  // 初回検索ラベル：URLまたはハッシュからtypeを取得
  let typeFromHash = hashValue.replace(/^movie_+/, '');
  let typeFromParam = params.get('type');
  if (typeFromHash === 'subscription') {
    typeFromHash = 'plus';
  }
  if (typeFromParam === 'subscription') {
    typeFromParam = 'plus';
  }
  let firstSearchType = typeFromParam || typeFromHash || 'new';
  if (!Object.keys(searchLabel).includes(firstSearchType)) {
    firstSearchType = 'new';
  }
  // 検索ラベル
  const [searchTypeList, setSearchTypeList] = useState({
    new: firstSearchType === 'new',
    benefit: firstSearchType === 'benefit',
    plus: firstSearchType === 'plus',
    purchased: firstSearchType === 'purchased',
    favorite: firstSearchType === 'favorite',
  });

  const [isFirstLoad, setIsFirstLoad] = useState<boolean>(false);
  const [isResetLoading, setIsResetLoading] = useState<boolean>(false);
  const [isLoading, setIsLoading] = useState<boolean>(false);
  // 追加読み込みの可否
  const [canMoreRead, setCanMoreRead] = useState<boolean>(true);
  const [isMoreReading, setIsMoreReading] = useState<boolean>(false);

  // 詳細モーダル:null/falseでなければ表示
  const [detailSale, setDetailSale] = useState<SaleModel|null|boolean>(null);
  // クリックカウント済みIDリスト
  const [clickedIdList, setClickedIdList] = useState<string[]>([]);

  const backgroundColor = '#f5f5f5';
  const grayColor = '#d3d3d3';
  const favoriteColor = '#F172A3';
  const benefitColor = '#63822D';


  // 初回データ取得
  useEffect(() => {
    if(!isFirstLoad) {
      // 表示データ初期化
      setDispSaleList([]);
      // 初回動画データ取得
      fetchSaleList(
        isLoading,
        searchWord,
        searchTypeList,
        []
      );
      setTimeout(() => {
        setIsFirstLoad(true);
      }, 500)
    }
  }, [isFirstLoad]);


  // スクロール検知：追加読み込み
  useEffect(() => {
    const handleScroll = () => {
      if(isLoading || isMoreReading || !canMoreRead) return; 
      // スクロール位置
      const scrollTop = window.scrollY;
      const windowHeight = window.innerHeight;
      const docHeight = document.documentElement.scrollHeight;
      if (
        // 一番下-windowHeight分までスクロール
        scrollTop + windowHeight*2 >= docHeight - 5 &&
        dispSaleList.length > 0
      ) {
        // 追加読み込み
        setIsMoreReading(true);
        fetchSaleList(
          isLoading,
          searchWord,
          searchTypeList,
          dispSaleList
        ).finally(() => {
          setTimeout(() => {
            setIsMoreReading(false);
          }, 50)
        });
      }
    };
    // スクロール検知
    window.addEventListener('scroll', handleScroll);
    return () => {
      window.removeEventListener('scroll', handleScroll);
    };
  }, [isLoading, isMoreReading, canMoreRead, dispSaleList]);


  // 検索ワード(リセットする)
  useEffect(() => {
    if(isFirstLoad) {
      // 初期化
      setSaleTypeList(defaultSaleTypeList);
      setIsResetLoading(true);
      // 再読み込み
      fetchSaleList(
        isLoading,
        searchWord,
        searchTypeList,
        []
      );
    }
  }, [searchWord])


  // 検索タイプ変更
  useEffect(() => {
    if(isFirstLoad) {
      // 検索タイプ
      const activeType = Object.entries(searchTypeList)
        .find(([key, val]) => val)?.[0] ||
        'normal';
      // 検索タイプの動画一覧
      const activeSaleList = saleTypeList[activeType as keyof typeof saleTypeList];
      if(activeSaleList && activeSaleList.length>0) {
        // 検索済み
        setDispSaleList(activeSaleList);
      } else {
        // 初回読み込み
        setSearchWord('');
        setIsResetLoading(true);
        // 再読み込み
        fetchSaleList(
          isLoading,
          '',
          searchTypeList, 
          []
        );
      }
    }
  }, [searchTypeList])

  // (ランダム表示)検索タイプをすべてfalseに
  function chgAllSearchTypeDefault() {
    setSearchTypeList({
      new: true,
      benefit: false,
      plus: false,
      purchased: false,
      favorite: false,
    });
  }
  // 検索タイプをすべてfalseに
  function chgAllSearchTypeFalse() {
    setSearchTypeList({
      new: false,
      benefit: false,
      plus: false,
      purchased: false,
      favorite: false,
    });
  }



  // 動画一覧の保持
  useEffect(() => {
    if(dispSaleList && dispSaleList.length>0) {
      // 検索タイプ
      const activeType = Object.entries(searchTypeList)
        .find(([key, val]) => val)?.[0] ||
        'normal';
      // 現在のリストを saleTypeList に保存
      setSaleTypeList(prev => ({
        ...prev,
        [activeType]: dispSaleList, // 現在表示しているものを格納
      }));
    }
  }, [dispSaleList])


  // 保存用の全データ更新
  function getUpdatedSaleInAllTypes(
    prevList: typeof defaultSaleTypeList,
    updatedSale: SaleModel
  ): typeof defaultSaleTypeList {
    const newList: typeof prevList = {} as typeof prevList;

    Object.entries(prevList).forEach(([type, arr]) => {
      const typedArr = arr as SaleModel[];
      newList[type as keyof typeof prevList] = typedArr.map(s =>
        s.id === updatedSale.id ? { ...s, ...updatedSale } : s
      );
    });

    return newList;
  }


  // 動画データ取得(API実行)
  async function fetchSaleList(
    isLoading: boolean,
    //引数にしないと取得できないタイミングがある
    useSearchWord: string | null = null,
    useSearchTypeList: any = null,
    befDispSaleList: SaleModel[]
  ) {
    if(!isLoading) {
      setIsLoading(true);
      try {
        // 最新のリクエストID
        const requestId = ++latestRequestId.current;
        // 読み込み済みデータID配列
        const readIdList: number[] = befDispSaleList.map(sale => sale.id);
        // API実行
        const resp = await requestApi({
          inc: '/backend/api/functions/user/sale/list',
          firstSaleId: firstSaleId,
          readIdList: readIdList,
          searchWord: useSearchWord!=null? useSearchWord : searchWord,
          searchedWordList: searchedWordList,
          searchTypeList: useSearchTypeList? useSearchTypeList : searchTypeList,
        });
        // 検索済みワード
        let newSearchedWordList = [
          ...searchedWordList,
          ...searchWord.split(/[\s\u3000]+/).filter(Boolean)
        ];
        newSearchedWordList = Array.from(new Set(newSearchedWordList));
        setSearchedWordList(newSearchedWordList);
        // 最新のリクエストでなければ破棄
        if (requestId !== latestRequestId.current) return;
        // データ取得
        setConfig(resp.config);
        setUser(resp.user);
        setUserOrg(resp.userOrg);
        setBannerList(resp.bannerList || []);
        setDispSaleList([...befDispSaleList, ...resp.dispSaleList]);
        setInstList(resp.instList);
        setIsPlus(resp.isPlus==1 || resp.isPlus=='1');
        setIsFullAccess(resp.isFullAccess==1 || resp.isFullAccess=='1');
        setIsCheckFullAccess(true);
        setIsFullaccessPurchased(resp.isFullaccessPurchased==1 || resp.isFullaccessPurchased=='1');
        setTelecomUrl(resp.telecomUrl);
        setTelecomTagb(resp.telecomTag);
        SET_TELECOM_CLIENTIP(resp.TELECOM_CLIENTIP);
        SET_BASE_URL_SSL(resp.BASE_URL_SSL);
        SET_SUBSCRIPTION_NAME(resp.SUBSCRIPTION_NAME);
        // 追加読み込みの可否
        if(resp.dispSaleList.length == 0) {
          setTimeout(() => {
            setCanMoreRead(false);
          }, 50)
        }

      } catch (err) {
        if (err instanceof Error) {
          console.warn(err.message);
        }

      } finally {
        setTimeout(() => {
          setIsLoading(false);
          setIsResetLoading(false);
        }, 100);
      }
    }
  }


  useEffect(() => {
    if(isResetLoading) {
      // 表示データ初期化
      setDispSaleList([]);
      // 追加読み込みの可否更新
      setCanMoreRead(true);
      // 一番上にスクロール
      window.scrollTo({ top: 0 });
    }
  }, [isResetLoading])


  // 初回詳細表示
  useEffect(() => {
    if(firstSaleId && dispSaleList.length>0) {
      try {
        const firstSale = dispSaleList.find(sale => sale.id == Number(firstSaleId));
        if(firstSale) {
          setDetailSale(firstSale);
        }
      } finally {
        // 初回読み込みの指定削除(追加読み込み対応)
        setFirstSaleId(null);
      }
    }
  }, [firstSaleId, dispSaleList])


  // 詳細モーダル判定
  useEffect(() => {
    if(!detailSale) {
      setDetailSale(null);
    }
  }, [detailSale])


  // フルアクセスで検索不可のラベルが指定された場合
  useEffect(() => {
    if(isFullAccess && isFirstLoad) {
      // 再検索の確認
      const activeSearchKey = (Object.keys(searchTypeList) as Array<keyof typeof searchTypeList>)
        .filter((key) => searchTypeList[key])[0];
      if(
        activeSearchKey === 'plus' ||
        // フルアクセス：購入なく所持中検索
        (
          activeSearchKey === 'purchased' &&
          !isFullaccessPurchased
        )
      ) {
        // 再度検索(searchTypeListをdefaultに)
        chgAllSearchTypeDefault();
        // 表示のリセット
        setDispSaleList([]);
      }
    }
  }, [isFullAccess, isFullaccessPurchased, isFirstLoad])



  const contextVal = {
    user: user,
    userOrg: userOrg,
    isPlus: isPlus,
    isFullAccess: isFullAccess,
    isCheckFullAccess: isCheckFullAccess,
    isFullaccessPurchased: isFullaccessPurchased,
    config: config,
    instList: instList,
    telecomUrl: telecomUrl,
    telecomTag: telecomTag,
    TELECOM_CLIENTIP: TELECOM_CLIENTIP,
    BASE_URL_SSL: BASE_URL_SSL,
    SUBSCRIPTION_NAME: SUBSCRIPTION_NAME,
    // 読み込み
    isLoading: isLoading,
    isMoreReading: isMoreReading,
    // 表示データ
    dispSaleList: dispSaleList,
    setDispSaleList: setDispSaleList,
    // 保存用動画データ
    saleTypeList: saleTypeList,
    setSaleTypeList: setSaleTypeList,
    getUpdatedSaleInAllTypes: getUpdatedSaleInAllTypes,
    // 検索
    searchWord: searchWord,
    setSearchWord: setSearchWord,
    searchLabel: searchLabel,
    searchTypeList: searchTypeList,
    setSearchTypeList: setSearchTypeList,
    chgAllSearchTypeDefault: chgAllSearchTypeDefault,
    chgAllSearchTypeFalse: chgAllSearchTypeFalse,
    // 詳細
    detailSale: detailSale,
    setDetailSale: setDetailSale,
    clickedIdList: clickedIdList,
    setClickedIdList: setClickedIdList,
    // style
    backgroundColor: backgroundColor,
    grayColor: grayColor,
    favoriteColor: favoriteColor,
    benefitColor: benefitColor,
  }


  return (
    <SaleListContext.Provider value={contextVal}>
    <div style={{
      backgroundColor: backgroundColor,
      padding: isPc
        ? `${window.innerHeight * 0.01}px ${window.innerWidth * 0.1}px 0`
        : `${window.innerHeight * 0.01}px 0 0`,
    }}>

      <img src='/images/page/sale/list/head_pc.png?251121' style={{width: '100%'}} />

      {/* 検索 */}
      <SaleListSearch />

      {/* バナー */}
      <SaleListBanner bannerList={bannerList} />

      <div>
        {(dispSaleList && dispSaleList.length>0) ?
          <div
            style={{
              display: 'flex',
              flexWrap: 'wrap',
              gap: isPc ? '20px' : '12px',
              justifyContent: isPc ? 'flex-start' : 'center',
              padding: '0 0 30px',
            }}
          >
            {/* 動画一覧 */}
            {dispSaleList.map((sale: SaleModel, index: number) => {
              return (
                <div
                  key={index}
                  id={`${sale?.id}`}
                  style={{
                    flex: isPc
                      ? '0 0 calc((100% - (20px * 2)) / 3)' // ← 3列時、gapを正確に引く
                      : '0 0 100%',
                    boxSizing: 'border-box',
                  }}
                >
                  <SaleListItem sale={sale} />
                </div>
              );
            })}
            {/* ローディング */}
            {isLoading &&
              <div style={{width: '100%', alignSelf: 'center', marginTop: 20}}>
                <Loading width='10%' />
              </div>
            }
          </div>
        :
          <>
            {!isLoading &&
              <>
                {/* データなし */}
                <SaleListNoData />
              </>
            }
          </>
        }
      </div>


      {/* 画面全体ローディング */}
      <SaleListLoading
        isFirstLoad={isFirstLoad}
        isResetLoading={isResetLoading}
      />

      {/* 詳細モーダル */}
      <Modal
        comp={
          <SaleListDetailModal
            detailSale={detailSale}
            modalHeight={isPc? '85vh' : '85vh'}
          />
        }
        isDispModal={detailSale!=null && detailSale!=false && detailSale!=true}
        setIsDispModal={setDetailSale}
        modalWidth={isPc? '55%' : '95%'}
        modalMaxHeight={isPc? '85vh' : '85vh'}
        isDispClose={true}
        isBackClose={true}
      />

    </div>
    </SaleListContext.Provider>
  );
}
  
export default SaleList;